import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription } from 'rxjs';
import { News } from 'src/app/data/models/interfaces/news';
import { NewsService } from 'src/app/data/services/news.service';
import { FileDto } from 'src/app/data/models/dto/file.dto';
import { separateFilePath } from 'src/app/modules/shared/util/file-path.util';

@Component({
  selector: 'app-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.scss'],
})
export class NewsDetailsComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChildren('background') background!: QueryList<any>;
  subscriptions: Subscription[] = [];
  newsId: string | undefined;
  news: News | undefined;
  visualized: number = -1;
  sent: number = 0;
  pending: number = 0;
  authorizedTrue: number = 0;
  authorized: number = 0;
  loadingSummary = false;
  height: any;
  backgroundFilePath: string | FileDto | null | undefined;

  constructor(
    private activatedRoute: ActivatedRoute,
    private newsService: NewsService,
  ) {
    const subscription = this.activatedRoute.params.subscribe(
      (params: Params) => {
        this.newsId = params['id'];
      }
    );
    this.subscriptions.push(subscription);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subs) => subs.unsubscribe);
  }

  async ngOnInit(): Promise<void> {
    if (this.newsId) {
      await this.getNews(this.newsId);
      await this.getSummary(this.newsId);
      this.calcAuthorizations();
    }
  }

  ngAfterViewInit() {
    this.background.changes.subscribe((result: any) => {
      if (this.background.last && this.background.last.nativeElement) {
        this.height = this.background.last.nativeElement.height;
      }
    });
  }

  async getNews(newsId: string): Promise<void> {
    this.news = await this.newsService.getById(newsId).toPromise();
    if (
      this.news.backgroundFile &&
      typeof this.news.backgroundFile === 'object'
    ) {
      const x = separateFilePath(this.news.backgroundFile.path);
      this.backgroundFilePath = `${x.path}${encodeURIComponent(x.name)}`;
    }
  }

  async getSummary(newsId: string): Promise<void> {
    this.loadingSummary = true;
    try {
      const summary = await this.newsService.getSummary(newsId);
      this.sent = summary.eligibles;
      this.visualized = summary.visualizations;
    } catch (error) {
      this.sent = 0;
      this.visualized = 0;
    }
    this.loadingSummary = false;
  }

  calcAuthorizations(): void {
    if (this.news!.authorized && this.news!.authorized.length > 0) {
      this.authorized = this.news!.authorized.length;
      this.authorizedTrue = this.news!.authorized.filter(
        (el) => el.answer === true
      ).length;
    }
    this.pending = this.sent - this.authorized;
  }  
}
